<router-outlet (activate)="onActivate($event)"></router-outlet>
<app-cookie *ngIf="getCookieConsent() == null"></app-cookie>